export default function SolutionOverview() {
  const solutions = [
    {
      icon: 'ri-map-pin-line',
      title: 'Mapping Critical SKUs',
      description: 'Identify components tied to downtime exposure'
    },
    {
      icon: 'ri-time-line',
      title: 'Response-Time Expectations',
      description: 'Define clear SLA-style response standards'
    },
    {
      icon: 'ri-radar-line',
      title: 'Readiness Monitoring',
      description: 'Track real-time readiness signals'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Single-Point Accountability',
      description: 'Establish clear ownership across parties'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Structured Reporting',
      description: 'Deliver comprehensive SLA-style visibility'
    }
  ];

  return (
    <section id="solution" className="py-24 lg:py-32 bg-[#F8F7F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-12 lg:gap-16">
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-2 bg-[#0A5F5C] rounded-full"></div>
              <span className="text-[#0A5F5C] font-semibold text-sm uppercase tracking-wider">Our Approach</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-6">
              A Readiness & Coordination Layer
            </h2>
            <p className="text-lg text-[#5A6670] leading-relaxed mb-6">
              BrightSync strengthens predictability for high-urgency components by establishing a structured coordination framework.
            </p>
            <p className="text-[#5A6670] leading-relaxed">
              We do not replace suppliers. We do not require system overhauls. We improve coordination clarity within your existing ecosystem.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="grid md:grid-cols-2 gap-6">
              {solutions.map((solution, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 ${
                    index === 2 ? 'md:translate-y-8' : ''
                  }`}
                >
                  <div className="w-12 h-12 bg-[#0A5F5C]/10 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${solution.icon} text-2xl text-[#0A5F5C]`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1A2332] mb-3">
                    {solution.title}
                  </h3>
                  <p className="text-[#5A6670] leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
